import { ROUTES_NAMES } from './common';

export const DEFAULT_BROADCAST_MESSAGE_COLOR = '#e75e40';

export const BROADCAST_MESSAGES_STATUSES = {
  active: 0,
  pending: 1,
  expired: 2,
};

export const BROADCAST_MESSAGE_VIEWS = {
  login: 'login',
  exploitation: 'exploitation',
  administration: 'administration',
  notifications: 'notifications',
  profile: 'profile',
  allViews: 'all-views',
  allPlaylists: 'all-playlists',
};

export const ROUTES_NAMES_TO_BROADCAST_MESSAGES = {
  [ROUTES_NAMES.login]: BROADCAST_MESSAGE_VIEWS.login,
  [ROUTES_NAMES.home]: BROADCAST_MESSAGE_VIEWS.login,
  [ROUTES_NAMES.error]: BROADCAST_MESSAGE_VIEWS.login,

  [ROUTES_NAMES.exploitationDeclareTicketRules]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationDynamicInfos]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationPbehaviors]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationEventFilters]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationSnmpRules]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationMetaAlarmRules]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationScenarios]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationIdleRules]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationFlappingRules]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationResolveRules]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationLinkRules]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationExternalDataTables]: BROADCAST_MESSAGE_VIEWS.exploitation,
  [ROUTES_NAMES.exploitationRemediation]: BROADCAST_MESSAGE_VIEWS.exploitation,

  [ROUTES_NAMES.adminRights]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminUsers]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminRoles]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminBroadcastMessages]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminPlaylists]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminPlanning]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminRemediation]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminHealthcheck]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminKPI]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminEventsRecords]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminAnomalyMonitoredConnectors]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminJobsManagement]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminTemplateTesting]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminCustomObjectsExternalAuthTokens]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminCustomObjectsExternalDataTables]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminCustomObjectsEntityInfosProperties]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminCustomObjectsIcons]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminCustomObjectsMaps]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminCustomObjectsTags]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminCustomObjectsLlms]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminSettingsUserInterface]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminSettingsViewsImportExport]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminSettingsNotifications]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminSettingsCommentTemplates]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminSettingsWidgetTemplates]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminSettingsStorageSettings]: BROADCAST_MESSAGE_VIEWS.administration,
  [ROUTES_NAMES.adminSettingsStateSettings]: BROADCAST_MESSAGE_VIEWS.administration,

  [ROUTES_NAMES.notifications]: BROADCAST_MESSAGE_VIEWS.notifications,

  [ROUTES_NAMES.profilePatterns]: BROADCAST_MESSAGE_VIEWS.profile,
  [ROUTES_NAMES.profileThemes]: BROADCAST_MESSAGE_VIEWS.profile,

  [ROUTES_NAMES.view]: BROADCAST_MESSAGE_VIEWS.allViews,
  [ROUTES_NAMES.viewKiosk]: BROADCAST_MESSAGE_VIEWS.allViews,
  [ROUTES_NAMES.alarms]: BROADCAST_MESSAGE_VIEWS.allViews,

  [ROUTES_NAMES.playlist]: BROADCAST_MESSAGE_VIEWS.allPlaylists,
};
